import styled, { css } from 'styled-components';

export const HalfColumn = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: ${theme.spacings.medium};
    width: 50%;
  `}
`;
